import { PaginatedResponse } from '@/calendesk/models/DTO/Response/Interface/PaginatedResponse'
import { Expose, Type } from 'class-transformer'
import UserSubscriptionPaymentTransaction from '@/calendesk/models/DTO/Response/UserSubscriptionPaymentTransaction'

export default class UserSubscriptionPaymentTransactionResponse extends PaginatedResponse {
  @Expose()
  @Type(() => UserSubscriptionPaymentTransaction)
  public data!: Array<UserSubscriptionPaymentTransaction>
}
